import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UseReevaluateTaggingGameMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	impersonationContext?: Api.IImpersonationContext;
}

export function useReevaluateTaggingGameMutation({
	onSuccess,
	onError,
	impersonationContext,
}: UseReevaluateTaggingGameMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async () => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'contact/reevaluateTaggingGame',
				}),
				'POST'
			);
		},
		onSuccess,
		onError,
	});
}
